module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', [(_vm.collabUser) ? _c('md-avatar', [(_vm.collabUser.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.collabUser.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]) : _c('md-avatar', [_c('img', {
    attrs: {
      "src": require('../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]), _vm._v(" "), (_vm.collabUser) ? _c('div', {
    staticClass: "md-list-text-container collaborator-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.collabUser.username))])]), _vm._v(" "), _c('div', {
    staticClass: "collaborator-role-wrapper"
  }, [(_vm.isAdministrator || _vm.user.uid === _vm.collaborator.uid) ? _c('span', {
    staticClass: "role-text-edit",
    attrs: {
      "contenteditable": ""
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.cancelEdit.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.ignoreKeydown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        return _vm.ignoreKeydown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveEdit(_vm.collaborator.uid, $event)
      }],
      "blur": function($event) {
        return _vm.stopEdit(_vm.collaborator.uid, $event)
      }
    }
  }, [_vm._v(_vm._s(_vm.collaborator.role))]) : _c('span', {
    staticClass: "role-text-edit"
  }, [_vm._v(_vm._s(_vm.collaborator.role))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collabUser.email))])]) : _c('div', {
    staticClass: "md-list-text-container collaborator-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.collaborator && _vm.collaborator.name || ''))])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator && _vm.collaborator.role || ''))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.collaborator && _vm.collaborator.email || ''))])]), _vm._v(" "), _c('md-list-expand', [_c('md-list', {
    staticClass: "sub-list"
  }, [_c('md-list-item', [_c('md-layout', {
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Layer Permissions")])])], 1), _vm._v(" "), _c('md-list-expand', [_c('md-list', {
    staticClass: "sub-list"
  }, [_c('md-list-item', [_c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('span', [_vm._v("Edit")])])], 1), _vm._v(" "), _c('span', [_vm._v("Layer Name")])], 1), _vm._v(" "), _vm._l((_vm.layers), function(layer) {
    return _c('layer-permission', {
      key: layer.id,
      attrs: {
        "layer": layer,
        "editable": _vm.editable,
        "collaborator": _vm.collaborator
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": _vm.openCollaboratorAccessModal
    }
  }, [_c('md-layout', {
    attrs: {
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Collaborator Access")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cc9ba76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/collaborator.vue
// module id = 1227
// module chunks = 21